import {CreatedMaintenanceRecordRequest} from '@di-shared/api/di/__generated';

interface UseSestSearchParamsProps {
  searchParams: URLSearchParams;
}

function useSestSearchParams({searchParams}: UseSestSearchParamsProps) {
  function getSestCodesFromParams() {
    return searchParams.getAll('sestCode') as CreatedMaintenanceRecordRequest.sestCode[];
  }

  function getToggledSestCodes(sestCode: CreatedMaintenanceRecordRequest.sestCode) {
    const prevSestCodes = getSestCodesFromParams();
    if (!prevSestCodes.some((prevSestCode) => prevSestCode === sestCode)) {
      return [...prevSestCodes, sestCode];
    } else {
      return [...prevSestCodes.filter((prevSestCode) => prevSestCode !== sestCode)];
    }
  }

  function isCheckedSest(sestCode: CreatedMaintenanceRecordRequest.sestCode) {
    const paramSestCodes = getSestCodesFromParams();
    return paramSestCodes.includes(sestCode);
  }

  return {searchParams, getToggledSestCodes, getSestCodesFromParams, isCheckedSest};
}

export default useSestSearchParams;
